import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const GooglePlayColor = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      d="M11.4647 11.5525L3.07504 20.3423C3.16925 20.6762 3.33855 20.9841 3.57 21.2426C3.80146 21.501 4.08893 21.7031 4.41046 21.8334C4.73199 21.9637 5.07905 22.0188 5.42512 21.9944C5.77119 21.97 6.1071 21.8668 6.40717 21.6927L15.8471 16.3163L11.4647 11.5525Z"
      fill="#EA4335"
    />
    <path
      d="M19.9482 10.0584L15.8659 7.72026L11.2709 11.7526L15.8847 16.3038L19.9357 13.9907C20.2946 13.8027 20.5952 13.5202 20.805 13.1736C21.0147 12.827 21.1256 12.4296 21.1256 12.0245C21.1256 11.6194 21.0147 11.222 20.805 10.8754C20.5952 10.5288 20.2946 10.2463 19.9357 10.0584H19.9482Z"
      fill="#FBBC04"
    />
    <path
      d="M3.07504 3.66294C3.02433 3.85042 2.9991 4.04388 3.00002 4.23809V19.7672C3.00053 19.9613 3.02574 20.1546 3.07504 20.3423L11.7523 11.7776L3.07504 3.66294Z"
      fill="#4285F4"
    />
    <path
      d="M11.5273 12.0026L15.8659 7.72026L6.43843 2.31884C6.08376 2.11112 5.68038 2.00111 5.26937 2C4.77298 1.99902 4.28988 2.16038 3.89371 2.45948C3.49755 2.75857 3.21005 3.17901 3.07504 3.65669L11.5273 12.0026Z"
      fill="#34A853"
    />
  </Icon>
));

export default GooglePlayColor;
